import { $$ } from './env';

/*
 * Hiệu ứng xuất hiện khi cuộn (mobile + trang con): phần tử .reveal hiện dần khi vào màn hình.
 * Khối [data-lazy-frame] chỉ được gắn .is-ready (mới tải ảnh nền CSS) khi sắp cuộn tới.
 */
export function initReveal(root = document) {
  const items = $$('.reveal, [data-lazy-frame]', root);
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-inview', 'is-ready'));
    return;
  }
  const readyIo = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-ready');
      readyIo.unobserve(en.target);
    });
  }, { rootMargin: '120% 0px' });
  // threshold theo % diện tích sẽ KHÔNG BAO GIỜ đạt với khối cao hơn nhiều màn hình (bài viết dài)
  // → dùng ngưỡng 0 + thu hẹp đáy khung nhìn 12%: chạm vào vùng nhìn thấy là hiện
  const viewIo = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-inview');
      viewIo.unobserve(en.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
  items.forEach((el) => {
    if (el.hasAttribute('data-lazy-frame')) readyIo.observe(el);
    if (el.classList.contains('reveal') || el.hasAttribute('data-lazy-frame')) viewIo.observe(el);
  });
}
